import React from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  startInspection: PropTypes.func.isRequired,
};

function StartInspectionWorkModal(props) {

    return (
        <div className="modal fade" id="startRealInspection" tabIndex="-1" role="dialog" aria-labelledby="startRealInspection" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600">
                            { __('app.questions.start_inspection_popup_title') }
                        </h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>
                            { __('app.questions.start_inspection_popup_message') }
                        </p>
                        <button onClick={() => props.startInspection() }
                        className="btn btn-success d-block w-100 mt-5" data-dismiss="modal" aria-label="Close">
                            { __('app.questions.start_inspection_popup_button') }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
  
}

StartInspectionWorkModal.propTypes = propTypes;

export default StartInspectionWorkModal;